const quoteList = {
  title: 'Quotes Received',
  select: 'Select',
  discountOff: 'off',
  coverage: 'Coverage',
  features: 'Features',
  policyLimit: 'Policy Limit',
  deductible: 'Deductible',
  retroactiveCover: 'Retroactive Cover',
  extendedReportingPeriod: 'Extended Reporting Period',
  noPolicyLimits: 'No policy limits available',
  noDeductibles: 'No deductibles available',
  noRetroactiveCover: 'No retroactive covers provided',
  noCompulsoryRetroactiveCover:
    'Free retroactive compulsory coverage starting from {{retroactiveStartDate}} through till effective date of this policy.',
  noExtendedReportingPeriod: 'No extended reporting period options available',
  forMoreDetails: 'For more details, please review',
  termsAndConditions: 'Terms & Conditions',
  discountApplied: 'Discount Applied',
  totalDiscount: 'Total discount',
  applied: 'Applied',
  selectQuotation: 'Select Quotation',
  continueToPay: 'Continue to Pay',
  selectionSuccess: 'Quotation selected successfully',
  selectionError: 'Failed to select quotation',
  bestValue: 'Best Value',
  policyDuration: 'Policy Duration',
  policyLimitLabel:
    'SAR {{oneTimeOccurrence}} per one occurrence and SAR {{aggregateOccurrence}} aggregate (annually)',
  onYears: 'On {{years}} Years',
  benefitsDescription:
    'Benefits you will get for {{years}} years policy duration or more.',
  benefitsHeaderContent: 'Choose {{years}} years or more to get {{benefits}}',
  policyHolderDetails: 'Policy Holder Details',
  policyHolderId: 'Policyholder Id:',
  specialty: 'Specialty:',
  benefitsDesc:
    'Tameeni recommends selecting longer policy durations to experience more benefits',
  seeBenefits: 'See benefits',
  priceStability: 'Better value at a lower price',
  continuityOfCoverage: 'Continuous coverage for a longer period',
  discountsOnOtherProducts: 'Discounts on other Tameeni products',
  noAnnualRenewalNeeded: 'No need to renew the policy annually',
  resetFilters: 'Clear filter(s)',
  applyFilters: 'Apply filter(s)',
  filterAndSort: 'Filter and Sort',
  sortBy: 'Sort By',
  priceLowToHigh: 'Sort Lowest to highest',
  priceHighToLow: 'Sort highest to lowest',
  insuranceCompanies: 'Insurance Companies',
  tamaraHintDescription:
    'Split your payments into equal instalments with Tamara',
  tabbyHintDescription: 'Split your payments into equal instalments with Tabby',
  upgradeYourPolicy: 'Upgrade your policy',
  exclusiveDeal: 'Exclusive Deal',
  upgradePolicyTitle:
    'Select longer policy duration to experience more benefits',
  totalPrice: 'Total Price:',
  policyFeatures: 'Policy features',
  termsApplied: 'Terms and conditions are applied',
  skip: 'Continue with only one year coverage',
  proceedWithOffer: 'Proceed with Offer',
  benefits: 'Benefits',
  benefitsAddedToPolicy:
    '{{count}} Benefits successfully add to your policy! More benefits available for longer duration...',
  specialtyDiscount: {
    popupTitle: 'A special discount for {{specialtyName}} professionals',
    popupBody:
      'Get {{percent}}% off your Medical Malpractice Insurance. Use the code below at checkout. Offer valid until {{endDate}}.',
    copyCode: 'Copy code',
    copied: 'Copied!',
    viewQuotes: 'View quotes',
    label:
      '{{percent}}% off for {{specialtyName}} professionals. Use code <voucher>{{voucherCode}}</voucher> at checkout.',
    copy: 'Copy',
    copyFailed: 'Couldn’t copy. Please copy the code manually: {{voucherCode}}',
  },
} as const

export default quoteList
